// @flow
// LEGACY
import universal from "react-universal-component";
import { UniversalComponentError } from "../components/UniversalComponentError";

const sliceNames: Array<string> = [
  "About",
  "AdvanceCalculator",
  "CardContainer",
  "CentredHero",
  "ComparisonTable",
  "Cookies",
  "EmailSignUp",
  "Faqs",
  "FeeCalculator",
  "ForSaleCarousel",
  "ForSaleList",
  "FullWidthCarousel",
  "GoogleHire",
  "HomepageCta",
  "LeftAlignedHero",
  "MaxThreeColTable",
  "NestimateCta",
  "PasswordSignUp",
  "PlainCentredHero",
  "RichTextWithButtons",
  "ScrollDestination",
  "TableSlice",
  "TextAndImage",
  "TextAndFullWidthImage",
  "Trustpilot",
  "TwoCards",
];

export const slices = sliceNames.reduce(
  (acc, name) => ({
    ...acc,
    // $FlowFixMe this works but flow hates it
    [name]: universal(import(`./${name}/index`), {
      error: UniversalComponentError,
      ignoreBabelRename: true,
      key: "UniversalRender",
      loading: () => null,
    }),
  }),
  {},
);
